<template lang="pug">
  .tour(v-if="tour")
    .tour__border.tour__border--top
    .tour__border.tour__border--right
    .tour__border.tour__border--bottom
    .tour__border.tour__border--left
    .tour__corner.tour__corner--tl
    .tour__corner.tour__corner--tr
    .tour__corner.tour__corner--bl
    .tour__corner.tour__corner--br
    .tour__decor-top
    .tour__decor-bottom
    .tour__decor-left
    .tour__title(v-if="h1") {{h1}}
    .tour__content
      .tour__text(v-if="tour.text") {{tour.text}}
      router-link.tour__btn(v-if="tour.btnText", to="/") {{tour.btnText}}



</template>

<script>
import EventBus from '@/eventBus';

//import '@/components/tour/tour.styl';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

// @ is an alias to /src
//import Events from '@/components/events/Events.vue';

export default {
  name: 'Tour',

  mixins: [AjaxHelpersVue],

  data() {
    return {
      tour: null
    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    // Загрузка данных для страницы
    EventBus.$on('loadTourPage', params => {
      this.request(params.url);
    });
  },

  methods: {
    request(url) {
      this.req('TourPage:getTourPage', {url}, res => {
        if(this.checkProperty(res.content)) {
          this.tour = res.content;
        }
      }, 'tour');
    }
  }
}
</script>
